import {AbstractControl, ValidationErrors} from '@angular/forms';

export function phoneValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) return null;

  // Check if it's a valid Rwanda phone number format (+250XXXXXXXXX)
  const phoneRegex = /^\+250[0-9]{9}$/;

  if (!phoneRegex.test(control.value)) {
    return { invalidPhone: true };
  }

  const mobilePrefix = control.value.substring(4, 6);
  const validPrefixes = ['72', '73', '78', '79'];

  if (!validPrefixes.includes(mobilePrefix)) {
    return { invalidPhone: true };
  }

  return null;
}
